<app-statuswidget [objRecordDetails]="objRecordDetails"></app-statuswidget>
<div class="row">
  <div class="col-sm-12">
    <app-viewform (arRecordValue)="onRecordFetchCompletion($event)" [objRecordDetails]="objRecordDetails"></app-viewform>
  </div>
</div>
